import { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useListType } from 'Stores/ListStore/ListStore';
import { useGetMakesBySlugs } from 'Stores/MakesStore/MakesStore';
import { useGetModelsById } from 'Stores/ModelsStore/ModelsStore';
import type { FilterQuery } from 'Types/filter';
import { formatFiltersToQuery } from 'Utilities/filterQuery/formatFiltersToQuery';
import { getMakeModelDictionary } from 'Utilities/makeModel/makeModel.helpers';

import useSortOrder from '../vehicleList/useSortOrder/useSortOrder';

/*
 * This hook is used to generate query based on the filters selected.
 * Query is using human readable strings for make and models - make=audi&model=a4 whereas filters are using unique ids,
 * and there is some calculations needed to determine query values.
 */

export const useCalculateQueryFromFilters = (): FilterQuery => {
	const getMakesBySlugs = useGetMakesBySlugs();
	const getModelsById = useGetModelsById();
	const filters = useFilters();
	const { defaultOrder, defaultSort } = useSortOrder();
	const listType = useListType();

	const selectedMakes = getMakesBySlugs(filters?.make);
	const selectedModels = getModelsById(filters?.model);
	const makeAndModel = getMakeModelDictionary({ selectedMakes, selectedModels });

	const calculatedQueryFromFilters = formatFiltersToQuery({
		defaultOrder,
		defaultSort,
		filters: { ...filters, listType },
		makeAndModel,
	});

	return calculatedQueryFromFilters;
};
